import * as browserHistory from 'history';
const history = browserHistory.createBrowserHistory();
export default history;
